import React from 'react';
import { Callout } from '../deck/Callout';
import { StepList } from '../deck/StepList';
import { StepSlide } from '../deck/StepSlide';
import { LoginMockup } from '../mockups/LoginMockup';
export function SignInSlide() {
  return <StepSlide step={1} title="Sign in to Stripe" visual={<LoginMockup data-id="element-246" data-mp="2ev0hhc5iw4hz" />} visualLabel="Stripe sign-in page with the address bar, email, password, and Sign in button marked 1 to 4" data-id="element-245" data-mp="2jvxyvmipkuif">
      <StepList items={[<>
            Type <strong data-id="element-248" data-mp="2ou98px90750n">dashboard.stripe.com</strong> in the address bar, then press{' '}
            <strong data-id="element-249" data-mp="32kl1lydex7su">Enter</strong>.
          </>, <>
            Email: <strong data-id="element-250" data-mp="32mysrw4z1zv4">donate@leslieoutreach.org</strong>
          </>, <>
            Password: <strong data-id="element-251" data-mp="2xnunhgl64ma2">LeslieOutreach2025!</strong>
          </>, <>
            Click <strong data-id="element-252" data-mp="3cjk04o4grn24">Sign in</strong>.
          </>]} data-id="element-247" data-mp="2st8bbb79ipox" />
      <Callout title="Password not working?" data-id="element-253" data-mp="37kqm8ul9lu1f">
        Click the blue words "Forgot your password?" (blue box) and follow the email Stripe
        sends you.
      </Callout>
    </StepSlide>;
}